const t = {
  name: "Bucket",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 2H2V4H4.05401L4.89659 19.1664C4.98491 20.7562 6.29977 22 7.89197 22H16.108C17.7002 22 19.0151 20.7562 19.1034 19.1664L19.2256 16.9671C19.4808 16.9889 19.7391 17 20 17H22V15H20C19.7763 15 19.555 14.9895 19.3366 14.969L19.946 4H22V2ZM17.3604 14.4852C14.8028 13.4432 13 10.9321 13 8V6H11V8C11 12.0094 13.6218 15.4065 17.2445 16.5704L17.1065 19.0555C17.077 19.5854 16.6388 20 16.108 20H7.89197C7.36124 20 6.92295 19.5854 6.89351 19.0555L6.0571 4H17.9429L17.3604 14.4852Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Bucket
};
